import { render, staticRenderFns } from "./DomainCard.vue?vue&type=template&id=24cc3912&"
import script from "./DomainCard.vue?vue&type=script&lang=ts&"
export * from "./DomainCard.vue?vue&type=script&lang=ts&"
import style0 from "./DomainCard.vue?vue&type=style&index=0&id=24cc3912&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports